import React from 'react'
import { Route, Redirect } from 'react-router-dom'

import { hasGates } from 'utils/access'

const getRedirect = ({ pathname }) => {
  return pathname === '/' ? '/gated' : '/'
}

export const PrivateRoute = ({ requiredGate = 'ABM', component: Component, ...rest }) => {
  return (
  <Route {...rest} render={props => (
    hasGates(requiredGate) ? (
      <Component {...props}/>
    ) : (
      <Redirect to={{
        pathname: getRedirect(props.location)
      }}/>
    )
  )}/>
)
    }
